import { Type } from "class-transformer";
export class JobRechercheEntry {
    fileName: string;
    @Type(() => Date)
    fileDate: Date;
    line: string;
    lineNumber = 0;
}
